import {Box, Button, Card, CardContent, Chip, Grid, Toolbar, Typography} from "@material-ui/core";
import * as React from 'react'
import {connect, MapStateToProps} from "react-redux";
import {withRouter} from 'react-router'
import {NavLink, RouteComponentProps} from 'react-router-dom'
import styled from "styled-components";
import {getRow, RouteType} from "lib/crud";
import {isLoading} from "lib/progress";
import {generateCrudPath} from "lib/router";
import {State} from "lib/store";
import {Student} from "lib/students";
import {getFirstInvalidSection, isTestCorrect, Test, testName} from "lib/test";

const Footer = styled.div`
  width: 100%;
  background: #FFFFFF;
  padding: 15px;
`

type StateToProps = {
    readonly student: Student
    readonly test: Test
    readonly isLoading: boolean
    readonly isTestCorrect: boolean
    readonly firstInvalidSection: number
}

type Params = {
    parentId: string
    id: string
}

type PreviewFooterState = {
    section: number
}

class PreviewFooterComponent extends React.Component<StateToProps & RouteComponentProps<Params>, PreviewFooterState> {
    state: PreviewFooterState = {
        section: 0
    }

    public render = () => <Footer style={{borderTop: 'solid 1px rgba(224, 224, 224, 1)'}}>
        <Grid container spacing={4}>
            <Grid item sm>
                <Typography
                    variant="h4"
                    display="inline"
                    style={{color: 'rgba(0,0,0,0.87)'}}
                >
                    {this.props.student.lastName} {this.props.student.firstName}
                </Typography>
                <Box>
                    [{this.props.student.identifier}]
                </Box>
            </Grid>
            {this.props.isTestCorrect ? null : <Grid item>
                <Chip label="Wypełnij wszystkie wymagane pola, żeby zakończyć test" style={{background: 'rgba(220, 0, 78, .6)', color: '#FFFFFF'}} />
            </Grid>}
            <Grid item>
                <Button
                    variant="outlined"
                    color="primary"
                    component={NavLink}
                    to={generateCrudPath(testName, RouteType.EDIT, {parentId: this.props.student.id || ' ', id: this.props.test.id || ' '}) + '?section=' + (this.props.firstInvalidSection + 1)}
                >
                    Edytuj
                </Button>
            </Grid>
            <Grid item>
                <Button
                    variant="contained"
                    color="primary"
                    form="test-form"
                    type="submit"
                    disabled={!this.props.isTestCorrect}
                >
                    Zakończ test
                </Button>
            </Grid>
        </Grid>
    </Footer>
}

const mapStateToProps: MapStateToProps<StateToProps, {}, State> = state => ({
    student: getRow(state => state.students)(state),
    test: getRow(state => state.tests)(state),
    isLoading: isLoading(state),
    isTestCorrect: isTestCorrect(state),
    firstInvalidSection: getFirstInvalidSection(state)
})

export const PreviewFooter = withRouter(connect(mapStateToProps)(PreviewFooterComponent))